
import { Skeleton } from "@/components/ui/skeleton";

export const ProjectsSkeleton = () => (
  <div className="max-w-7xl mx-auto py-20 px-6 section-spacing">
    <Skeleton className="h-12 w-1/3 mx-auto mb-6" />
    <Skeleton className="h-8 w-2/3 mx-auto mb-12" />
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      {[...Array(6)].map((_, i) => (
        <div key={i} className="space-y-4">
          <Skeleton className="h-48 w-full rounded-xl" />
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      ))}
    </div>
  </div>
);

export const AboutSkeleton = () => (
    <div className="max-w-6xl mx-auto py-20 px-6 section-spacing">
        <Skeleton className="h-12 w-1/3 mx-auto mb-16" />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="space-y-2">
                {[...Array(8)].map((_, i) => (
                    <Skeleton key={i} className="h-16 w-full rounded-lg" />
                ))}
            </div>
            <div className="lg:col-span-2">
                <Skeleton className="h-80 w-full rounded-2xl" />
            </div>
        </div>
    </div>
);

export const ServicesSkeleton = () => (
    <div className="max-w-6xl mx-auto py-20 px-6 section-spacing">
        <Skeleton className="h-12 w-1/3 mx-auto mb-6" />
        <Skeleton className="h-8 w-2/3 mx-auto mb-16" />
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
             {[...Array(4)].map((_, i) => (
                <div key={i} className="space-y-4 p-6 glass-morphism rounded-xl">
                    <Skeleton className="h-12 w-12 rounded-lg" />
                    <Skeleton className="h-6 w-3/4" />
                    <Skeleton className="h-16 w-full" />
                </div>
            ))}
        </div>
    </div>
);

export const GenericSkeleton = () => (
    <div className="max-w-6xl mx-auto py-20 px-6 section-spacing space-y-8">
        <Skeleton className="h-12 w-1/3 mx-auto" />
        <Skeleton className="h-8 w-2/3 mx-auto" />
        <div className="space-y-4 pt-8">
            <Skeleton className="h-40 w-full rounded-xl" />
            <Skeleton className="h-40 w-full rounded-xl" />
        </div>
    </div>
);
